/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { AriesCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { Flex, VStack } from "@panda/jsx";

import { AriesCard } from "./AriesCard.molecule";

export const AriesCardsSection = ({ config, cards }: AriesCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.48">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Flex gap="eds.dimension.16" flexWrap="wrap">
								{(cards || []).map((card) => (
									<AriesCard key={`aries-card-${card.id}`} {...card}></AriesCard>
								))}
							</Flex>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
